import { useIntl } from 'react-intl'
import { RecipientSelectorModal } from './RecipientSelectorModal'
import { CAMPAIGN_MESSAGES as M } from '../campaignMessages'

type Props = {
  show: boolean
  onHide: () => void
  onSubmit: (payload: { contactId: string }[]) => Promise<void>
  onSync?: (selectedContactIds: string[]) => Promise<void>
  loading?: boolean
  campaignName?: string
  campaignId?: string
  initialTargetCount?: number
  onBulkAdded?: () => void
}

export const AddTargetModal = ({
  show,
  onHide,
  onSubmit,
  onSync,
  loading,
  campaignId,
  initialTargetCount = 0,
  onBulkAdded,
}: Props) => {
  const intl = useIntl()
  const handleSave = async (selectedIds: string[]) => {
    if (onSync) {
      await onSync(selectedIds)
    } else {
      const targets = selectedIds.map((id) => ({ contactId: id }))
      await onSubmit(targets)
      onHide()
    }
  }

  return (
    <RecipientSelectorModal
      show={show}
      onHide={onHide}
      onSave={handleSave}
      initialSelectedIds={[]}
      initialTargetCount={initialTargetCount}
      confirmLabel={intl.formatMessage(loading ? M.saving : M.saveTargets)}
      campaignId={campaignId}
      onBulkAdded={onBulkAdded}
    />
  )
}
